import { render, staticRenderFns } from "./Concursos.vue?vue&type=template&id=09cea7f2&scoped=true"
import script from "./Concursos.vue?vue&type=script&lang=js"
export * from "./Concursos.vue?vue&type=script&lang=js"
import style0 from "./Concursos.vue?vue&type=style&index=0&id=09cea7f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09cea7f2",
  null
  
)

export default component.exports